import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type ReportRequest = {
  clientId?: string | null;
  checkId?: string | null;
};

export type Report = {
  contentType?: string | null;
  data?: string | null;
};

export class Reports extends Resource<ReportRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("reports", axiosInstance);
  }

  public async generate(reportRequest: ReportRequest): Promise<Report> {
    return await this.request({
      method: Method.GET,
      query: { ...reportRequest }
    });
  }
}
